import { useModuleData } from '@/rebuild/hooks/data/useModuleData';
import { useMultiMarketQuote } from '@/rebuild/materials/shared/quote/useMultiMarketQuote';
import { useStore } from '@/utils/vue-api';
import { useCommonData } from '@/hooks';
import { computed, getCurrentInstance } from 'vue';
import dayjs from 'dayjs';

export function useBannerCore() {
	const { getOrganizationName, getColumnData } = useCommonData();

	const { proxy } = getCurrentInstance();

	const store = useStore();
	const getBaseData = computed(() => store.getters.getBaseData || {});

	const logo = computed(() => getColumnData.value?.logo);
	const getUpperMarket = computed(() => getBaseData.value.market?.toUpperCase() || '');
	const getStockCode = computed(() => getBaseData.value.code || '');

	const { quote } = useModuleData();
	const loadQuoteData = () => quote.refresh();

	const { cleanFormatQuoteRawDataFn } = useMultiMarketQuote();

	const marketSymbol = computed(() => store.getters.getCurrUnitTips);
	const getQuoteData = computed(() => quote.data?.data || {});

	const forceFormatPriceFunc = (marketRow, prop) => {
		const rawValue = cleanFormatQuoteRawDataFn(marketRow, prop);
		if (typeof rawValue !== 'number') return rawValue;
		return rawValue?.toFixed(3);
	};
	const formatStockTimeLabelFunc = date => {
		if (!date) return '';
		const formatTime = dayjs(date).valueOf();
		const formatValue = dayjs(formatTime).format('YYYY-MM-DD');
		return `${proxy.$t('enterprise.common-a.until')} ${formatValue} 16:00  （${proxy.$t('enterprise.UTC')}）`;
	};

	return {
		logo,
		getOrganizationName,
		getUpperMarket,
		getStockCode,

		loadQuoteData,
		getQuoteData,

		cleanFormatQuoteRawDataFn,
		marketSymbol,
		forceFormatPriceFunc,
		formatStockTimeLabelFunc
	};
}
